import moment from "moment";

export const INTERVAL_OPTIONS = [
  {
    label: "Minute",
    value: "MINUTE"
  },
  {
    label: "10 Minute",
    value: "TEN_MINUTE"
  },
  {
    label: "Hour",
    value: "H"
  },
  {
    label: "Day",
    value: "D"
  },
];

export const DASH_STYLE = {
  DASH: "dashdot",
  SOLID: "solid",
  DOT: "dot"
};

export const CHART_TYPE = {
  SCATTER: "scattergl"
};

export const CHART_MODE = {
  LINE: "lines"
};

export const INTERVAL_MAP = {
  MINUTE: [1, "minute"],
  TEN_MINUTE: [10, "minute"],
  HOUR: [1, "hour"],
  DAY: [1, "day"],
  MONTH: [1, "month"]
};

export const INTERVAL_THRESHOLDS = {
  HOUR: moment.duration(732, "day").valueOf(),
  TEN_MINUTE: moment.duration(120, "day").valueOf(),
  MINUTE: moment.duration(30, "day").valueOf()
};

export const FORECAST_MONTHS = [
  {
    label: "6",
    value: 6
  },
  {
    label: "12",
    value: 12
  },
  {
    label: "18",
    value: 18
  },
  {
    label: "24",
    value: 24
  },
  {
    label: "30",
    value: 30
  },
];
